var _defs, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3e34bc4278"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.601562 15 L 56.101562 15 L 56.101562 60 L 18.601562 60 Z M 18.601562 15 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "#ffffff",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "#ffffff",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3e34bc4278)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002850",
    d: "M 42.1875 33.613281 C 45.285156 31.941406 47.394531 28.664062 47.394531 24.902344 C 47.394531 19.445312 42.953125 15.003906 37.496094 15.003906 C 32.039062 15.003906 27.597656 19.445312 27.597656 24.902344 C 27.597656 28.664062 29.707031 31.941406 32.804688 33.613281 C 24.652344 35.710938 18.601562 43.101562 18.601562 51.898438 L 18.601562 59.097656 C 18.601562 59.59375 19.003906 59.996094 19.5 59.996094 L 55.492188 59.996094 C 55.992188 59.996094 56.394531 59.59375 56.394531 59.097656 L 56.394531 51.898438 C 56.394531 43.101562 50.339844 35.710938 42.1875 33.613281 Z M 42.1875 33.613281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.1ef3add6c97807190c919e256672a2e5.svg";
export { ForwardRef as ReactComponent };